// @flow
import { getScreenStyles } from '../../../../utils'

export const Container = {
  width: '505px',
  display: 'flex',
  flexFlow: 'column nowrap',
}

export const Content = {
  flexGrow: 1,
  padding: '0 20px 20px 20px',
}

export const ButtonContainer = getScreenStyles(
  'xs',
  {
    display: 'flex',
    justifyContent: 'stretch',
    flexFlow: 'column nowrap',
    margin: '10px 0',
  },
  {
    margin: '10px 0',
    width: 'auto',
    flexGrow: '-1',
  }
)

export const AlertContainer = {
  marginTop: '8px',
}

export const AlertContent = {
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  width: '100%',
}

export const IconWrapper = {
  fontSize: '1.33em',
  marginRight: '12px',
  color: 'rgb(253, 162, 54)',
}

export const AlertMessageContainer = {
  color: 'black',
  fontSize: '12px',
  fontWeight: 'normal',
}
